<template>
    <div>
        <app-field :error="error" :classes="classes" :append="append">
            <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

            <app-button element="button" class="btn  btn--primary  btn--primary--sml" @click="modalOpen = true">Edit</app-button>
        </app-field>

        <app-modal v-if="modalOpen" tabindex="-1" role="dialog" @modal-close="closeModal">
            <div
                class="modal__box  modal__box--xlarge text-left"
            >
                <div class="p-6 bg-grey-lightest border-b border-grey-lighter">
                    <h2 v-html="name ? name : 'WYSIWYG'"></h2>
                </div>
                <div>
                    <div class="p-12">
                        <app-trix-base
                            name="cmptrix"
                            v-model="content"
                            placeholder=""
                            @change="handleChange"
                            class="w-full"
                        ></app-trix-base>
                    </div>
                </div>
                <div class="modal__footer">
                    <div class="flex items-center ml-auto">
                        <app-button element="button" class="btn  btn--secondary  btn--secondary--sml" @click="modalOpen = false">Save</app-button>
                    </div>
                </div>
            </div>
        </app-modal>
    </div>
</template>

<script>
    /* Components */
    import Button from '@/components/Button';
    import Modal from '@/components/Modal';
    import TrixBase from '@/components/TrixBase';
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';

    export default {
        name: 'app-field-trix',

        components: {
            'app-button': Button,
            'app-modal': Modal,
            'app-field': Field,
            'app-label': Label,
            'app-trix-base': TrixBase
        },

        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            name: {
                required: false
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            draftId: uuidv4(),
            modalOpen: false,
            content: ''
        }),

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        mounted() {
            if (this.value) {
                this.content = this.value;
            }
        },

        methods: {
            closeModal() {
                this.modalOpen = false
            },

            handleChange(value) {
                this.content = value

                this.$emit('input', this.content)
            },
        },
        watch:{
            value(value) {
                this.handleChange(value)
            }
        }
    }

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
        )
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>



// WEBPACK FOOTER //
// src/components/composer/Fields/Trix.vue